import { format } from 'date-fns';

export function isValidDate(date) {
  const parsedDate = new Date(date);
  return !isNaN(parsedDate.getTime());
}

export function getFormattedDate(dateValue) {
  const date = isValidDate(dateValue) ? new Date(dateValue) : new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function getDaysByFrequency(frequency) {
  switch (frequency?.toLowerCase()) {
    case "weekly":
      return 7;
    case "monthly":
      return 30;
    case "quarterly":
      return 90;
    case "yearly":
      return 365;
    default:
      throw new Error("Invalid frequency");
  }
}

export function getFrequencyByDays(days) {
  if (typeof days !== "number" || days < 0) {
    return ""
  }

  if (days <= 7) {
    return "weekly";
  } else if (days <= 30) {
    return "monthly";
  } else if (days <= 90) {
    return "quarterly";
  } else {
    return "yearly";
  }
}

export function getFormattedDateTime(dateValue) {
  const date = isValidDate(dateValue) ? new Date(dateValue) : new Date();
  return format(date, 'MMM dd, yyyy, h:mm a');
}
